import { useSignal } from '@preact/signals'
import { FrameSourceState } from '@scandit/web-datacapture-core'
import { useCallback } from 'preact/hooks'
import { MarkupText } from 'preact-i18n'
import screenFull from 'screenfull'
import { Grid, Icon, Transition } from 'semantic-ui-react'
import { useStore, useTracker } from '../../store'
import { ScannerMode } from '../../store/InitialOptionsStore'
import { classnames } from '../../utils'
import { TransparentButton } from '../atoms'
import { SignupLink } from '../atoms/SignupLink'
import { Show } from '../directives'
import ExpandableListSelector from './expandableLists'
import FullscreenInfo from './FullScreenInfo'
import MainMenu from './MainMenu'
import styles from './MainPage.module.css'
import Tutorial from './Tutorial'

const MainPage = () => {
  const tracker = useTracker()
  const store = useStore()
  const collapsed = useSignal(false)
  const activeSubMenu = useSignal('')
  const open =
    store.initialOptionsStore.launched.value &&
    store.cameraStore.state.value === FrameSourceState.On &&
    !store.errorsStore.hasCameraAccessError.value
  const isLabelCapture = store.initialOptionsStore.scannerMode.value === ScannerMode.LabelScanning

  const toggleCollapsed = useCallback(() => {
    collapsed.value = !collapsed.value
  }, [collapsed])

  return (
    <>
      <Transition visible={open} duration={350} animation="fade down">
        <div class={styles.outer}>
          {!isLabelCapture && screenFull.isEnabled ? <FullscreenInfo /> : <div style={{ padding: '0.5rem' }} />}
          <div
            class={classnames({
              [styles.slider]: true,
              [styles.slideUp]: collapsed.value,
            })}
          >
            <Grid centered stackable className="container">
              <Grid.Row>
                <Grid.Column textAlign="center">
                  <MainMenu activeSubMenu={activeSubMenu} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <Show when={activeSubMenu.value === ''}>
              <TransparentButton id="main-menu-collapse-toggle" className={styles.toggle} onClick={toggleCollapsed}>
                <Icon size="large" name={collapsed.value ? 'chevron down' : 'chevron up'} />
              </TransparentButton>
            </Show>
          </div>
        </div>
      </Transition>
      <Show when={open && !isLabelCapture}>
        <SignupLink>
          <MarkupText id="info.signUpTrial" />
        </SignupLink>
      </Show>
      <Show when={open}>
        <Tutorial
          scannerMode={store.initialOptionsStore.scannerMode.value}
          onNextTip={() => tracker.sendEvent('Tutorial', 'advance')}
          onConfirmAction={() => tracker.sendEvent('Tutorial', 'skip')}
          onFinish={() => tracker.sendEvent('Tutorial', 'complete')}
        />
      </Show>
      <Show when={open}>
        <ExpandableListSelector />
      </Show>
    </>
  )
}
export default MainPage
